/** 用户短信签名管理 */

import React from 'react';
import { Button, Card, Row, Col, Form, Input, message, Modal, Spin, Popconfirm, Icon, Tooltip, Tag} from 'antd';
import Holder from "../../components/Holder";
import CkUpload from "../../components/CkUpload";
import { findSmssigns, delSmssigns, addSmssigns} from "../../services/smssigns";

const FormItem = Form.Item;
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};
class UserSmssignSetting extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            smssignModalVisible: false
        }
    }

    componentDidMount() {
        this.initData();
    }

    initData = () => {
        findSmssigns({userId: localStorage.getItem('userId')}).then(res => {
            if (res.code === 200) {
                this.setState({data: res.data});
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        });
    }

    handleDelSmssign = (id) => {
        delSmssigns({signId: id, userId: 'default'}).then(res => {
            if (res.code === 200) {
                message.success("删除成功");
                this.initData();
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        });
    }

    handleModalVisible = (flag) => {
        this.setState({smssignModalVisible: flag});
    }

    submitForm = (e) => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                console.log('Received values of form: ', values);
                addSmssigns(values).then(res => {
                    if (res.code === 200) {
                        message.success("新增成功!");
                        this.handleModalVisible(false);
                        this.initData();
                    } else {
                        message.error(res.msg,6);
                    }
                }).catch(err => {
                    message.warn("访问异常");
                });
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <Spin spinning={this.state.data.length === 0}>
            <div>
                <Button type="primary" ghost size="small" style={{marginBottom:7}} onClick={(e) => {
                    this.handleModalVisible(true);
                }}>新增签名</Button>
                {
                    this.state.data.length > 0
                    ?
                    this.state.data.map((item, index) => {
                        if (item.id === null) return false;
                        return (
                            <Card bodyStyle={{padding: "7px 15px"}} key={index}>
                                <Row gutter={8}>
                                    <Col span={6}>
                                        <Holder
                                            src={item.proofUrl}
                                            width={60}
                                            height={60}
                                            size={18}
                                            text={"A"}
                                        />
                                    </Col>
                                    <Col span={16}>
                                        <Row gutter={8}>
                                            <Col span={24}>
                                                <b>短信签名：</b><span>{item.sign}</span>
                                            </Col>
                                        </Row>
                                        <Row gutter={8}>
                                            <Col span={24}>
                                                <b>审核状态：</b>
                                                <span>
                                                    {item.status === 'APPROVED' ? <Tag color="#2db7f5">审核通过</Tag> : ""}
                                                    {item.status === 'PENDING' ? <Tag color="#87d068">待审核</Tag> : ""}
                                                    {item.status === 'REJECTED' ?<span><Tag color="#f50">已拒绝</Tag> <span style={{color:"red"}}>{item.approveRemarks}</span></span> : ""}
                                                </span>
                                            </Col>
                                        </Row>
                                        <Row gutter={8}>
                                            <Col span={24}>
                                                <b>申请时间：</b><span>{item.createTime}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={2}>
                                        {index != 0 &&
                                        <Popconfirm title={<span>您确定要删除吗?</span>}
                                                    onConfirm={(e) => {
                                                        this.handleDelSmssign(item.id);
                                                    }}>
                                            <a href="#" style={{float:'right'}}>删除</a>
                                        </Popconfirm>}
                                    </Col>
                                </Row>
                            </Card>
                        );
                    })
                    : ""
                }
                <Modal
                    visible={this.state.smssignModalVisible}
                    title="申请签名请联系QQ或微信客服，2025年315后运营商要求严格，需手动处理。必须材料：营业执照（非法人组织需机构代码证或其他）和操作人身份证正反面"
                    width="600px"
                    onCancel={() => this.handleModalVisible(false)}
                    onOk={()=>this.submitForm()}
                >
                    <Form>
                        <FormItem
                            {...formItemLayout}
                            label="短信签名"
                        >
                            {getFieldDecorator('sign', {
                                rules: [
                                    { required: true, message: '请输入签名' },
                                    { min:1, max:10, message: '签名最多10字，建议3-8字' },
                                    { pattern: /^[\u4e00-\u9fa5\uff08\uff09a-zA-Z0-9\(\)]+$/, message: '不能使用非法字符' }
                                ],
                            })(
                                <Input placeholder="请提交您的品牌或公司名称，可以替代默认短信【签到家】" autoComplete="off" />
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label={(
                                <span>
                                  证明材料&nbsp;
                                  <Tooltip title="上传证明材料（含：执照/商标/著作权/工作证/身份证等）">
                                    <Icon type="question-circle-o" />
                                  </Tooltip>
                                </span>
                            )}
                        >
                            {getFieldDecorator('proofUrl', {
                                getValueFromEvent: (fileUrlObj) => {
                                    return fileUrlObj.url;
                                }
                            })(
                                <CkUpload
                                    width={100}
                                    height={100}
                                />
                            )}
                        </FormItem>

                    </Form>
                </Modal>
            </div>
            </Spin>
        );
    }
}

export default Form.create({})(UserSmssignSetting);


// WEBPACK FOOTER //
// ./src/containers/user/UserSmssignSetting.jsx